import { SnackbarProvider } from "notistack";
import Mapbox from "../components/Mapbox/Mapbox";
import { Banner } from "../components/Banner";
import WelcomeModal from "../components/WelcomeModal";

export function MapPage() {
  return (
    <>
      <SnackbarProvider
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        dense={true}
        maxSnack={3}
      >
        <div className="map-and-banner-container">
          <Banner />
          <WelcomeModal />
          <Mapbox />
        </div>
      </SnackbarProvider>
    </>
  );
}
